import Simprug1 from "./simprug (1).webp";
import Simprug2 from "./simprug (2).webp";
import Simprug3 from "./simprug (3).webp";
import Simprug4 from "./simprug (4).webp";
import Simprug5 from "./simprug (5).webp";
import Simprug6 from "./simprug (6).webp";
import Simprug7 from "./simprug (7).webp";
import Simprug8 from "./simprug (8).webp";
import Simprug9 from "./simprug (9).webp";
import Simprug10 from "./simprug (10).webp";
import Simprug11 from "./simprug (11).webp";
import Simprug12 from "./simprug (12).webp";

const simprug = [
  Simprug1,
  Simprug2,
  Simprug3,
  Simprug4,
  Simprug5,
  Simprug6,
  Simprug7,
  Simprug8,
  Simprug9,
  Simprug10,
  Simprug11,
  Simprug12,
];

export default simprug;
